<div class="help-center">

  <!-- Top Banner CTA -->
  <div class="top-banner">
    <span class="highlight">NEW TO SALESMAX?</span>
    <button class="link-btn" (click)="getStarted()">Click here to get started in simple steps →</button>
    <button class="btn-link" style="float: right;" (click)="showGstTaxIdAlert({id : activeAccount?.account?.taxId})">@if (activeAccount?.account?.taxId) {
      <span>{{activeAccount?.account?.taxId}}</span>
    }&nbsp; Update Tax ID</button>
  </div>

  <!-- Search Bar -->
  <div class="search-box">
    <div class="search-box-form" [formGroup]="searchForm_activity">
      <input type="text" id="subscribeFormEg1" class="form-control"
        placeholder="Search: e.g., how to add user, upload leads..." aria-label="Search Query"
        formControlName="search_activity" style="height : 100%" (keydown.enter)="onEnter()" />

        <!-- Dynamic Buttons -->
        @if (searchForm_activity.get('search_activity').value == null
          || searchForm_activity.get('search_activity').value == ''
          || !searchHasRun) {
          <button type="button" class="btn-search btn btn-primary" (click)="onEnter()">
            Find
          </button>
        }

        @if (!(searchForm_activity.get('search_activity').value == null
          || searchForm_activity.get('search_activity').value == ''
          || !searchHasRun)) {
          <button type="button" class="btn-clear btn btn-danger" (click)="clearActivitySearchField(true)">
            Clear
          </button>
        }
      </div>
    </div>

    <!-- Suggestion Box -->
    @if (showSuggestion && suggestionText && searchHasRun) {
      <div class="suggestion-box">
        <h2 (click)="suggestedSearch(suggestionText)">
          Could not understand you. Did you mean:
          <span class="suggestion-text">{{ suggestionText }}</span>?
        </h2>
      </div>
    }

    <!-- Loading Skeleton -->
    @if (callingApi) {
      <div class="row">
        <div class="col-12">
          <div class="skeleton-wrapper">
            <ngx-skeleton-loader count="3" [theme]="{ 'border-radius': '6px', height: '48px', margin: '0.5rem 0' }">
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    }

    @if (action && actionDetail && actionDetail.length > 0) {
      <div class="d-flex flex-row videos-section">
        <h2>🎥 Quick Tutorials</h2>
        @if (!(searchForm_activity.get('search_activity').value == null
          || searchForm_activity.get('search_activity').value == ''
          || !searchHasRun)) {
          <button style="height: fit-content" type="button" class="ml-2 btn-clear btn btn-danger" (click)="clearActivitySearchField(true)">
            Clear
          </button>
        }
      </div>
      @for (item of actionDetail; track item) {
        <div class="video-card">
          <!-- Web Video -->
          @if (item.webVideoLink) {
            <div class="video-card-section">
              <div class="video-wrapper">
                <iframe [src]="item.webVideoLink" frameborder="0" allowfullscreen></iframe>
              </div>
              <div class="video-info">
                <a class="video-cta" (click)="takeAction(item.subAction)">{{ item.clickAction }}</a>
                @if (item.instructionWeb) {
                  <p class="video-instruction">
                    <strong>How to do on Webapp:</strong>
                    {{ item.instructionWeb }}
                  </p>
                }
              </div>
            </div>
          }
          <!-- App Video -->
          @if (item.appVideoLink) {
            <div class="video-card-section">
              <div class="video-wrapper">
                <iframe [src]="item.appVideoLink" frameborder="0" allowfullscreen></iframe>
              </div>
              <div class="video-info">
                <a class="video-cta">Instruction for App</a>
                @if (item.instructionApp) {
                  <p class="video-instruction">
                    <strong>How to do on App:</strong>
                    {{ item.instructionApp }}
                  </p>
                }
              </div>
            </div>
          }
        </div>
      }
    }


    <!-- Important Notice -->
    <div class="notice">
      <strong>IMPORTANT!!!</strong> All queries/support must go via Support Chat Channel only —
      no direct calls or WhatsApp.
      Write in detail with supporting screenshot/screen recording.
      <span class="avoid">Strictly avoid direct call or WhatsApp.</span>
    </div>

    <!-- Cards Section -->
    <div class="cards-container">

      <!-- Frequently Used -->
      <div class="card">
        <h3>📌 Frequently Used</h3>
        <ul>
          <li><button (click)="bulkUpload()">Bulk Upload Leads from Excel/CSV</button></li>
          <li><button (click)="addSingleLead()">Add Single Lead</button></li>
          <li><button (click)="viewExports()">View Exported Files</button></li>
          <li><button (click)="newLeadDistributionSetup()">Set up Lead Distribution</button></li>
          <li><button (click)="inviteNewUser()">Invite New User to Workspace</button></li>
        </ul>
      </div>

      <!-- Users & Teams -->
      <div class="card">
        <h3 style="cursor: pointer;"  class="card-title" (click)="goToUsers()">👥 Users & Teams</h3>
        <ul>
          <li><button (click)="inviteNewUser()">Invite New User</button></li>
          <li><button (click)="createTeam()">Create New Team</button></li>
          @if (appIssueCount > 0) {
            <li class="prominent-li">
              <button type="button" mat-flat-button color="warn" class="btn-prominent" (click)="goToAppStatus()">
                <span class="btn-left">
                  <mat-icon>health_and_safety</mat-icon>
                  <span>View App Health</span>
                </span>
                <span class="badge-issue">{{appIssueCount}} {{appIssueCount === 1 ? 'user' : 'users'}}</span>
              </button>
            </li>
          }
          @if (canAdministerGeofences()) {
            <li class="prominent-li">
              <button type="button" mat-flat-button color="primary" class="btn-prominent" (click)="goToGeofences()">
                <span class="btn-left">
                  <mat-icon>location_on</mat-icon>
                  <span>Geofences</span>
                </span>
                <span class="badge-new">NEW</span>
              </button>
            </li>
          }
        </ul>
        <button class="btn-link" (click)="goToUsers()">Go to Users & Teams</button>
      </div>

      <!-- Customize -->
      @if (canCustomizeWorkspace()) {
        <div class="card">
          <h3 style="cursor: pointer;" class="card-title" (click)="goToCustomization()">⚙️ Customize for Your Business</h3>
          <ul>
            <li><button (click)="viewProducts()">Your Products or Services</button></li>
            <li><button (click)="createProperty()">Create New Custom Property</button></li>
            <li><button (click)="createForm()">Create New Form</button></li>
            <li><button (click)="goToForms()">Link Form to Calls, Tasks</button></li>
            <li><button (click)="goToCustomization()">Customize Call Outcomes, Tasks</button></li>
            <li class="prominent-li">
              <button type="button" mat-flat-button color="primary" class="btn-prominent" (click)="quoteSettings()">
                <span class="btn-left">
                  <mat-icon>request_quote</mat-icon>
                  <span>Quotation Defaults</span>
                </span>
                <span class="badge-new">NEW</span>
              </button>
            </li>
          </ul>
          <button class="btn-link" (click)="goToCustomization()">View All Customization</button>
        </div>
      }

      <!-- Work & Automations -->
      <div class="card">
        <h3 style="cursor: pointer;" class="card-title" (click)="openWorkPipelineSetup()">🔄 Work & Automations</h3>
        <ul>
          <li class="prominent-li">
            <button type="button" mat-flat-button color="primary" class="btn-prominent" (click)="openWorkPipelineSetup()">
              <span class="btn-left">
                <mat-icon>work</mat-icon>
                <span>Manage Work Types</span>
              </span>
              <span class="badge-new">NEW</span>
            </button>
          </li>
        </ul>
      </div>

      <!-- Integrations -->
      <div class="card">
        <h3 style="cursor: pointer;" class="card-title" (click)="goToIntegrations()">🔗 Integrations</h3>
        <ul>
          <li><button (click)="goToIntegrations()">Connect WhatsApp Cloud API</button></li>
        </ul>
        <button class="btn-link" (click)="goToIntegrations()">View All Integrations</button>
      </div>

      <!-- Templates -->
      <div class="card">
        <h3 style="cursor: pointer;" class="card-title" (click)="goToTemplates()">💬 Message Templates</h3>
        <ul>
          <li><button (click)="createTemplate()">Create New Template</button></li>
          <li><button (click)="goToTemplates()">View All Templates</button></li>
        </ul>
      </div>

      <!-- Account -->
      <div class="card">
        <h3 style="cursor: pointer;" class="card-title" (click)="goToAccount()">👤 Account</h3>
        <ul>
          <li><button (click)="manageAccess()">Manage Role-Based Access</button></li>
          <li><button (click)="updateAccount()">Modify Workspace/Account Detail</button></li>
          <li><button (click)="updateAccountDefault()">Modify Workspace Defaults</button></li>
          <li><button (click)="removeDoNotTrack()">Manage Do Not Track Leads</button></li>
          @if (billingFeatureEnabled) {
          <li class="prominent-li">
            <button type="button" mat-flat-button color="primary" class="btn-prominent" (click)="openBilling()">
              <span class="btn-left">
                <mat-icon>credit_card</mat-icon>
                <span>Billing & Seats</span>
              </span>
              <span class="badge-new">NEW</span>
            </button>
          </li>
          }
        </ul>
        <button class="btn-link" (click)="goToAccount()">View Account Details</button>
      </div>

      <!-- Create New Workspace -->
      <div class="card special">
        <h3>🏢 Have another business?</h3>
        <p>Create a separate Workspace & manage sales for multiple businesses in one place.</p>
        <button class="btn-primary" (click)="createOrganzationButtonClicked()">Create New Workspace</button>
      </div>

    </div>

    <!-- Floating Chat Support -->
    <button class="chat-support-btn" (click)="openSupportChat()">💬 Chat Support</button>
  </div>
